import { RefObject, useEffect, useState } from 'react';

// Raises the members' wall once the locked collection scrolls into view,
// then holds the page in place.
export function useCollectionWall(targetRef: RefObject<HTMLElement>, resetKey: string) {
  const [walledRaw, setWalled] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const walled = walledRaw && !dismissed;

  useEffect(() => {
    setWalled(false);
    setDismissed(false);
  }, [resetKey]);

  useEffect(() => {
    if (walledRaw) return;
    const check = () => {
      const el = targetRef.current;
      if (!el) return;
      // Let the first row of the collection be seen before the wall rises.
      if (el.getBoundingClientRect().top < -window.innerHeight * 0.2) setWalled(true);
    };
    window.addEventListener('scroll', check, { passive: true });
    return () => window.removeEventListener('scroll', check);
  }, [walledRaw, targetRef, resetKey]);

  useEffect(() => {
    if (!walled) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [walled]);

  return { walled, dismiss: () => setDismissed(true) };
}
